<template>
    <div>
        <div class="modal-header">
            <button class="btn btn-default pull-right" @click="hideModal()">Zamknij</button>
            <button class="btn btn-success pull-right mr-4" @click="showCreateFood()">Utwórz danie</button>
            <h4 class="modal-title">Zaawansowane wyszukiwanie</h4>
        </div>
        <div class="modal-body">
            <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                <div class="add__food scrollbar" v-if="newFood">
                    <food-edit :food="newFood" :mode="'create'" class="right_box_container" ref="newFoodEdit">
                        <template slot="header">
                            <loading-button :loading="isLoading" :status="status" @click="createOrUpdateFood">
                                <i class="fa fa-save"></i>
                                Dodaj i zapisz do mojej bazy
                            </loading-button>
                            <a @click="hideCreateFood()" class="btn btn-default pull-right">Zamknij</a>
                        </template>
                        <template slot="multi_portion_food_portion_amount">
                            <div class="clearfix"/>
                            <div class="col-xs-2 text-left mt-3">
                                <label class="control-label" for="portionAmount">Ilość</label>
                            </div>
                            <div class="col-xs-2 mt-3">
                                <input type="number"
                                       class="form-control form-control-xs"
                                       id="portionAmount"
                                       :min="newFood.isMultiPortionFood() ? 1 : 0.1"
                                       :step="0.5"
                                       :max="newFood.isMultiPortionFood() ? newFood.portions : 999"
                                       v-bind:value="newFood.portion.amount"
                                       v-on:input="getPortionAmountOnInputListener(newFood, $event)"
                                       v-on:change="getPortionAmountOnChangeListener($event)"
                                >
                            </div>
                        </template>
                    </food-edit>
                </div>
            </transition>
            <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                <div class="add__food scrollbar" v-if="food">
                    <food-edit :food="food" class="right_box_container" :showSaveBtn="true" ref="foodEdit" :hide-replacing="true">
                        <template slot="header">
                            <a @click="addFood(food)" class="btn btn-success"

                            >
                                <i class="fa fa-plus" aria-hidden="true"></i> Dodaj</a>
                            <a @click="close()" class="btn btn-default pull-right">Zamknij</a>
                        </template>
                        <template slot="multi_portion_food_portion_amount">
                            <div class="clearfix"/>
                            <div class="col-xs-2 text-left mt-3">
                                <label class="control-label" for="portions">Ilość</label>
                            </div>
                            <div class="col-xs-2 mt-3">
                                <input type="number"
                                       class="form-control form-control-xs"
                                       id="portions"
                                       :min="1"
                                       :step="0.5"
                                       :max="food.portions"
                                       v-bind:value="food.portion.amount"
                                       v-on:input="getPortionAmountOnInputListener(food, $event)"
                                       v-on:change="getPortionAmountOnChangeListener($event)"
                                >
                            </div>
                        </template>
                    </food-edit>
                </div>
            </transition>
            <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
                <div class="add__food right_box_container" v-if="foodToShow">
                    <div>
                        <a @click="addFood(foodToShow)" class="btn btn-success"
                        > <i aria-hidden="true"
                                                                                     class="fa fa-plus"></i> Dodaj</a>
                        <a @click="action(foodToShow)" class="btn btn-primary"> <i aria-hidden="true"
                                                                                    class="fa fa-pencil-square-o"></i>
                            Edytuj</a>
                        <a @click="hideFoodDetails()" class="btn btn-default pull-right">Zamknij</a>
                        <h4>{{foodToShow.name}}</h4>
                        <div>
                            <p>
                                <strong>Przygotowanie:</strong>
                                {{foodToShow.recipe}}
                            </p>
                            <p>
                                <strong>
                                    Produkty:
                                </strong>

                                {{foodToShow.products.map(p => p.name).join(', ')}}
                            </p>
                            <p v-show="foodToShow.tags.length > 0">
                                <strong>
                                    Tagi:
                                </strong>
                                {{foodToShow.tags.join(', ')}}
                            </p>
                            <p v-show="foodToShow.diets.length > 0">
                                <strong>
                                    Dieta:
                                </strong>
                                {{foodToShow.diets.join(', ')}}
                            </p>
                            <p v-show="foodToShow.meals.length > 0">
                                <strong>
                                    Posiłki:
                                </strong>
                                {{foodToShow.meals.join(', ')}}
                            </p>
                            <p v-show="foodToShow.equipments.length > 0">
                                <strong>
                                    Wyposażenie:
                                </strong>
                                {{foodToShow.equipments.join(', ')}}
                            </p>

                            <p v-if="foodToShow.isMultiPortionFood()">
                                <strong>Wartości dla {{ foodToShow.portions }} {{ this.polishPlurals('porcję', 'porcje', 'porcji', foodToShow.portions) }}:</strong>
                            </p>

                            <div class="flex" :class="{'mb-3':foodToShow.isMultiPortionFood()}">
                                <div class="flex-item" v-for="(nutrients, group) in nutrientsGroups">
                                    <strong>{{group}}</strong>
                                    <div v-for="nutrient in nutrients" v-tooltip="nutrient.name">
                                        {{nutrient.shortName}}: {{nutrient.amount | round}} {{nutrient.unit}}
                                    </div>
                                </div>
                            </div>

                            <p v-if="foodToShow.isMultiPortionFood()">
                                <strong>Wartości dla 1 porcji:</strong>
                            </p>

                            <div class="flex" v-if="foodToShow.isMultiPortionFood()">
                                <div class="flex-item" v-for="(nutrients, group) in nutrientsGroups">
                                    <strong>{{group}}</strong>
                                    <div v-for="nutrient in nutrients" v-tooltip="nutrient.name">
                                      <span v-if="nutrient.name === 'Indeks glikemiczny'">{{nutrient.shortName}}: {{nutrient.amount | round}} {{nutrient.unit}}</span>
                                      <span v-else>{{nutrient.shortName}}: {{nutrient.amount/foodToShow.portions | round}} {{nutrient.unit}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="search__container">
                <div class="search__left">
                    <div class="row mb-10">

                        <div class="col-xs-2">
                            <label>Baza przepisów</label>
                            <vue-select :options="databaseOptions" single placeholder="Baza przepisów..."
                                      v-model="filters.database"></vue-select>
                        </div>

                        <div class="col-xs-3">
                            <label>Produkt</label>
                            <search-select
                                    multiple
                                    @item-selected="setProductFilter"
                                    :endpoint="configuration.search.product"
                                    placeholder="Szukaj produktów"></search-select>
                        </div>

                        <div class="col-xs-2 input-group-sm">
                            <label class="control-label">Posiłek</label>
                            <vue-select :options="configuration.meals" placeholder="Wybierz posiłek..." multiple
                                      v-model="filters.meal"></vue-select>
                        </div>
                        <div class="col-xs-2">
                            <label class="control-label">Dieta</label>
                            <vue-select :options="configuration.diets" placeholder="Wybierz dietę..." multiple
                                      v-model="filters.diets"></vue-select>
                        </div>
                        <div class="col-xs-3">
                            <label class="control-label">Tagi</label>
                            <vue-select :options="configuration.tags" placeholder="Wybierz tagi..." multiple
                                      v-model="filters.tags"></vue-select>
                        </div>
                    </div>
                    <div class="row mb-10">
                        <div class="col-xs-12">
                            <label>Uwzględnij</label>
                        </div>
                        <div class="col-xs-12">
                            <div class="row">
                              <div class="col-xs-2">
                                <permission-tooltip
                                    :permission="`creator_search_advanced_seasons`"
                                    :tooltip="{top: true, bottom: false}"
                                >
                                  <p-check name="type" v-model="filters.seasonality" type="checkbox" value="1"
                                           :disabled="!hasPermission('creator_search_advanced_equipments')"
                                           class="p-default" color="success-o">Sezonowość
                                  </p-check>
                                  <i class="fa fa-question-circle"
                                     v-tooltip="'Nie pokazuj dań z produktami, na które aktualnie nie ma sezonu'"></i>
                                </permission-tooltip>
                              </div>
                              <div class="col-xs-2">
                                <permission-tooltip
                                    :permission="`creator_search_advanced_equipments`"
                                    :tooltip="{top: true, bottom: false}"
                                    v-if="isAssignedToUser"
                                >
                                  <p-check name="type" v-model="filters.equipment" type="checkbox" value="1"
                                           :disabled="!hasPermission('creator_search_advanced_equipments')"
                                           class="p-default" color="success-o">Wyposażenie
                                  </p-check>
                                  <i class="fa fa-question-circle"
                                     v-tooltip="'Nie pokazuj dań, których pacjent nie może wykonać, gdyż nie ma takiego sprzętu kuchennego'"></i>
                                </permission-tooltip>
                              </div>

                                <div class="col-xs-2" v-if="isAssignedToUser">
                                    <p-check name="type" v-model="filters.allergens" type="checkbox" value="1"
                                             class="p-default" color="success-o">Produkty
                                        alergizujące
                                    </p-check>
                                    <i class="fa fa-question-circle"
                                       v-tooltip="'Nie pokazuj dań z produktami alergicznymi dla pacjenta'"></i>
                                </div>
                                <div v-if="isAssignedToUser" class="col-xs-2">
                                    <p-check name="type" v-model="filters.unliked" type="checkbox" value="1"
                                             class="p-default" color="success-o">Produkty nielubiane
                                    </p-check>
                                    <i class="fa fa-question-circle"
                                       v-tooltip="'Nie pokazuj dań z produktami nielubianymi/niewskazanymi dla pacjenta'"></i>
                                </div>
                              <div class="col-xs-2" style="display:none;">
                                <permission-tooltip
                                    :permission="`creator_search_advanced_equipments`"
                                    :tooltip="{top: true, bottom: false}"
                                >
                                  <p-check name="type" v-model="filters.only_seasonal" type="checkbox" value="1"
                                           :disabled="!hasPermission('creator_search_advanced_equipments')"
                                           class="p-default" color="success-o">Tylko sezonowe
                                  </p-check>
                                  <i class="fa fa-question-circle"
                                     v-tooltip="'Pokaż tylko sezonowe dania.'"></i>
                                </permission-tooltip>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-10">
                        <div class="col-xs-12">
                            <label>Wartości odżywcze</label>
                        </div>
                        <div class="col-xs-12">
                            <div class="row mb-10">
                                <div class="col-xs-3">
                                    <label>Kaloryczność</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.kcal.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" :min="filters.nutrients.kcal.from" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.kcal.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <label>Węglowodany</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.carbo.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.carbo.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <label>Białko</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.protein.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.protein.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <label>Tłuszcz</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.fats.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.fats.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-3">
                                    <label>Wymienniki węglowodanowe</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.ww.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.ww.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <label>Wymienniki białkowo-tłuszczowe</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.wbt.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.wbt.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <label>Ładunek glikemiczny</label>
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.gl.from" placeholder="od">
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="input-group input-group-sm">
                                                <input type="number" min="0" step="1"
                                                       class="form-control search-instant"
                                                       v-model="filters.nutrients.gl.to" placeholder="do">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 input-group-sm">
                            <label>Nazwa dania</label>
                            <input type="text" class="form-control" v-model="filters.name">
                        </div>
                    </div>
                    <div v-if="foodsWithLeftPortions.length > 0" class="row mt-5">
                        <div class="col-xs-8 col-xs-offset-2">
                            <div class="text-center text-bold">
                                <p>Dania do wykorzystania</p>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-condensed manage-meals-products-and-foods-table mb-5" v-if="foodsWithLeftPortions.length > 0">
                        <tbody>
                        <tr>
                            <th class="full-width">Nazwa</th>
                            <th class="text-center number__select__col">Porcje</th>
                            <th class="text-center nutrient__col" title="Energia">Kcal</th>
                            <th class="text-center nutrient__col" title="Węglowodany">W</th>
                            <th class="text-center nutrient__col" title="Białko">B</th>
                            <th class="text-center nutrient__col" title="Tłuszcze">T</th>
                            <th class="text-center nutrient__col" title="Błonnik">Bł</th>
                            <th style="min-width: 40px;"></th>
                        </tr>
                        <tr v-for="food in foodsWithLeftPortions">
                            <td>
                                <span v-bind:class="getMultiPortionFoodColorClass(food)">{{food.name}} ({{food.portions}}p.)</span>
                                <span class="label label-warning" :class="{hidden: !food.hasDisliked()}"
                                      v-tooltip="'Produkt w tym daniu jest nielubiany przez pacjenta'">
                            <i class="fa fa-thumbs-down"></i></span>

                                <span class="label label-danger"
                                      :class="{hidden: !food.hasAllergens()}"
                                      v-tooltip="'Produkt w tym daniu jest alergiczny dla pacjenta'">
                            <i class="fa fa-ban"></i></span>

                            </td>
                            <td class="text-center">
                                <input type="number"
                                       :min="0.5"
                                       :step="0.5"
                                       :max="getPortionAmountMax(food)"
                                       v-bind:value="food.portion.amount"
                                       v-on:input="getPortionAmountOnInputListener(food, $event)"
                                       v-on:change="getPortionAmountOnChangeListener($event)"
                                       class="form-control form-control-xs">
                            </td>
                            <td class="text-center">
                                {{food.calculateEnergy().amount | round}}
                            </td>
                            <td class="text-center">
                                {{ food.sumNutrientById(CARBO) | round }}
                            </td>
                            <td class="text-center">
                                {{ food.sumNutrientById(PROTEIN) | round }}
                            </td>
                            <td class="text-center">
                                {{ food.sumNutrientById(FATS) | round }}
                            </td>
                            <td class="text-center">
                                {{ food.sumNutrientById(FIBER) | round }}
                            </td>
                            <td class="text-center">
                                <button @click="addMultiPortionFood(food)"
                                        class="btn btn-xs btn-success">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div>
                        <table id="advanced-foods-search-table" class="table table-bordered table-condensed table-hover"
                               width="100%"
                               data-url="/menu-days/advanced-foods-search">
                            <thead>
                            <tr>
                                <th></th>
                                <th>Nazwa dania</th>
                                <th width="70" @click="orderBy = 'portions'">Porcje</th>
                                <th width="50" @click="orderBy = 'kcal'">Kcal</th>
                                <th width="50" @click="orderBy = 'carbo'">W</th>
                                <th width="50" @click="orderBy = 'protein'">B</th>
                                <th width="50" @click="orderBy = 'fats'">T</th>
                                <th width="50" @click="orderBy = 'fiber'">Bł</th>
                                <th width="80"></th>
                            </tr>
                            </thead>
                            <tfoot>
                            <tr>
                                <th></th>
                                <th>Nazwa dania</th>
                                <th>Porcje</th>
                                <th>Kcal</th>
                                <th>W</th>
                                <th>B</th>
                                <th>T</th>
                                <th>Bł</th>
                                <th></th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="search__right">
                    <div class="fixed scrollbar" ref="scrollbar">

                        <div class="navigation">
                            <div class="navigation--prev">
                                <div v-show="schema.getPrevNonEmptyDay(day.id)">
                                    <button @click="showPrevDay" class="btn btn-success btn-sm"
                                            v-tooltip="'Poprzedni dzień'">
                                        <i class="fa fa-angle-double-left"></i>
                                    </button>
                                </div>
                                <div v-show="day.getPrevPlan(plan.id)">
                                    <button @click="showPrevPlan" class="btn btn-success btn-sm"
                                            v-tooltip="'Poprzedni posiłek'">
                                        <i class="fa fa-angle-left"> </i>
                                    </button>
                                </div>
                            </div>
                            <div class="navigation--next">
                                <div v-show="day.getNextPlan(plan.id)">
                                    <button @click="showNextPlan" class="btn btn-success btn-sm"
                                            v-tooltip="'Następny posiłek'">
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div v-show="schema.getNextNonEmptyDay(day.id)">
                                    <button @click="showNextDay" class="btn btn-success btn-sm"
                                            v-tooltip="'Następny dzień'">
                                        <i class="fa fa-angle-double-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="day">
                            <div class="day__header">
                                <div>{{day.date | format_date}}</div>
                                <div>{{day.date | format_date('dddd') | capitalize}}</div>

                                <div class="plan__summary">
                                    <label>REALIZACJA</label>
                                    <div class="d-flex justify-content-between item--offset bg-success"
                                         v-tooltip="'Założeniowa wartość odżywcza'">
                                        <span>K: {{prescribedNutrients[KCAL]| integers}}</span>
                                        <span>W: {{prescribedNutrients[CARBO] | round}}</span>
                                        <span>B: {{prescribedNutrients[PROTEIN] | round}}</span>
                                        <span>T: {{prescribedNutrients[FATS] | round}}</span>
                                    </div>
                                    <div class="d-flex justify-content-between item--offset bg-info"
                                         v-tooltip="'Suma wartości odżywczych'">
                                        <span>K: {{totalNutrients[KCAL] | integers}}</span>
                                        <span>W: {{totalNutrients[CARBO] | round}}</span>
                                        <span>B: {{totalNutrients[PROTEIN] | round}}</span>
                                        <span>T: {{totalNutrients[FATS] | round}}</span>
                                    </div>
                                    <div class="d-flex justify-content-between item--offset">
                                        <span :class="indicatorClass(totalNutrients[KCAL], prescribedNutrients[KCAL])">K: {{calculatePercentage(totalNutrients[KCAL], prescribedNutrients[KCAL]) | integers}}%</span>
                                        <span :class="indicatorClass(totalNutrients[CARBO], prescribedNutrients[CARBO])">W: {{calculatePercentage(totalNutrients[CARBO], prescribedNutrients[CARBO])  | integers}}%</span>
                                        <span :class="indicatorClass(totalNutrients[PROTEIN], prescribedNutrients[PROTEIN])">B: {{calculatePercentage(totalNutrients[PROTEIN], prescribedNutrients[PROTEIN]) | integers}}%</span>
                                        <span :class="indicatorClass(totalNutrients[FATS], prescribedNutrients[FATS])">T: {{calculatePercentage(totalNutrients[FATS], prescribedNutrients[FATS]) | integers}}%</span>
                                    </div>
                                </div>

                            </div>

                            <plan v-for="dayPlan in day.plans" :key="dayPlan.id" :planId="dayPlan.id" :dayId="day.id"
                                  :class="[plan.id === dayPlan.id ? 'selected' : '']"></plan>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import {foodFactory} from '../../../factory/food.factory';
    import debounce from 'lodash/debounce';
    import PerfectScrollbar from 'perfect-scrollbar';
    import 'perfect-scrollbar/css/perfect-scrollbar.css';
    import {copyFood} from '../../../services/CopyMenuDay';
    import {multiPortionFoodsManager} from "../../../services/MultiPortionFoodsManager";
    import {polishPlurals} from "polish-plurals";
    import uuid from "uuid4";
    import {Portion} from "../../../model/portion.model";
    import {SharingService} from "../../../services/SharingService";
    import {
      CARBO,
      FATS,
      FIBER,
      KCAL,
      NutrientDetailsProvider,
      PROTEIN, WBT, WW
    } from "../../../services/NutrientDetailsProvider";
    import {trans} from "../../../app";
    import {FoodService} from "../../../services/FoodService";

    export default {
        data() {
            return {
                status: '',
                isLoading: false,
                newFood: null,
                foodToShow: null,
                plan: null,
                day: null,
                food: null,
                prescribedNutrients: {},
                orderBy: null,
                filters: {
                    name: null,
                    product: [],
                    meal: [],
                    diet: [],
                    tags: [],
                    nutrients: {
                        kcal: {
                            from: null,
                            to: null,
                        },
                        protein: {
                            from: null,
                            to: null,
                        },
                        fats: {
                            from: null,
                            to: null,
                        },
                        carbo: {
                            from: null,
                            to: null,
                        },
                        ww: {
                            from: null,
                            to: null,
                        },
                        wbt: {
                            from: null,
                            to: null,
                        },
                        gl: {
                            from: null,
                            to: null,
                        },
                    },
                    seasonality: 0,
                    equipment: 0,
                    unliked: 0,
                    allergens: 0,
                    database: {
                        label: 'Wszystkie',
                        value: 'all',
                    },
                    only_seasonal: 0,
                },
                table: null,
                foodsWithLeftPortions: [],
                isAssignedToUser: true,
                KCAL: KCAL,
                CARBO: CARBO,
                PROTEIN: PROTEIN,
                FATS: FATS,
                FIBER: FIBER,
            };
        },

        mounted() {
            const ps = new PerfectScrollbar('.scrollbar');
        },
        created() {
            const vm = this;
            this.debounceReload = debounce(this.reload, 1000);
            this.$nextTick(function () {
                this.table = $('#advanced-foods-search-table').DataTable({
                        lengthChange: false,
                        searching: false,
                        serverSide: true,
                        columns: [
                            {
                                className: 'details-control',
                                orderable: false,
                                data: null,
                                ordering: false,
                                width: '10px',
                                defaultContent: '<a class="btn btn-xs btn-success" title="Podgląd dania"><i class="fa fa-info-circle" aria-hidden="true"></i></a>',
                            },
                            {
                                data: 'name',
                                name: 'name',
                                searchable: true,
                                orderable: false,
                                render: (data, type, food) => {
                                    var html = food.name;

                                    if (food.hasAllergens()) {
                                        html += '&nbsp; <span id="allergy-selected" class="label label-danger"' +
                                            ' data-toggle="tooltip" title="Danie zawiera produkty alergiczne dla pacjenta">' +
                                            '<i class="fa fa-ban"></i>' +
                                            '</span>';
                                    }

                                    if (food.hasDisliked()) {
                                        html += '&nbsp; <span id="unlike-selected" class="label label-warning" data-toggle="tooltip" title="Danie zawiera produkty nielubiane przez pacjenta">' +
                                            '<i class="fa fa-thumbs-down"></i></span>';
                                    }

                                    const owner = SharingService.getOwnerIfShared(
                                        vm.configuration.sharedResources,
                                        food.externalId,
                                        'food'
                                    )
                                    if (owner) {
                                      html += '&nbsp; <span class="label" data-toggle="tooltip" title="Udostępnione przez ' + owner + '">' +
                                          '<i class="fa fa-fw fa-share-alt text-success" aria-hidden="true"></i></span>';
                                    }

                                    return html;
                                },
                            },
                            {
                                name: 'portions',
                                searchable: false,
                                render: (data, type, food) => {
                                    return food.portions;
                                },
                            },
                            {
                                name: 'kcal',
                                searchable: false,
                                render: (data, type, food) => {
                                    return Math.round(food.calculateEnergy(food.isMultiPortionFood()).amount * 100) / 100;
                                },
                            },
                            {
                                name: 'carbo',
                                searchable: false,
                                render: (data, type, food) => {
                                    return Math.round(food.sumNutrientById(CARBO, false) * 100) / 100;
                                },
                            },
                            {
                                data: 'protein',
                                name: 'protein',
                                searchable: false,
                                render: (data, type, food) => {
                                    return Math.round(food.sumNutrientById(PROTEIN, false) * 100) / 100;
                                },
                            },
                            {
                                data: 'fats',
                                name: 'fats',
                                searchable: false,
                                render: (data, type, food) => {
                                    return Math.round(food.sumNutrientById(FATS, false) * 100) / 100;
                                },
                            }, {
                                data: 'fibber',
                                name: 'fibber',
                                searchable: false,
                                render: (data, type, food) => {
                                    return Math.round(food.sumNutrientById(FIBER, false) * 100) / 100;
                                },
                            },
                            {
                                className: 'details-control',
                                orderable: false,
                                data: null,
                                ordering: false,
                                width: '10px',
                                defaultContent: '<a class="btn btn-xs btn-success" title="Dodaj danie"><i class="fa fa-plus" aria-hidden="true"></i></a>',
                            },
                        ],
                        ajax: {
                            url: vm.configuration.search.advanced,
                            cache: false,
                            dataSrc: (response) => {
                                return response.data.map(dto => foodFactory.createFromDto(dto));
                            },
                            data: (data) => {
                                data.filters = this.filters;
                                data.orderBy = this.orderBy;
                            },
                        },
                    },
                );

                this.table.on('click', 'td', function (e) {
                    const index = $(this).index();
                    const row = vm.table.row($(e.target).closest('td')).data();

                    if (index === 0) {
                        vm.showFoodDetails(row);
                    }

                    if (index === 8) {
                        vm.action(row);
                    }

                });
            });
            this.foodsWithLeftPortions = multiPortionFoodsManager.getFoodsWithLeftPortions(this.schema);
            this.$root.$on('multi_portion_food_removed_from_plan', (isMultiPortionFood) => {
                if (isMultiPortionFood) {
                    this.foodsWithLeftPortions = multiPortionFoodsManager.getFoodsWithLeftPortions(this.schema);
                }
            });
        },
        methods: {
            ...mapMutations([
                'hideModal',
                'showModal',
                'checkPlanRepetition',
            ]),
            close() {
                this.food = null;
            },
            addFood(food) {
                if (this.$refs.foodEdit) {
                    this.$refs.foodEdit.validateFood();
                }

                if (!food || !food.isValid()) {
                    return;
                }

                this.plan.addFood(copyFood(food));
                this.checkPlanRepetition(this.plan);
                this.food = null;
                this.foodToShow = null;
                this.foodsWithLeftPortions = multiPortionFoodsManager.getFoodsWithLeftPortions(this.schema);
            },
            addMultiPortionFood(food) {
                multiPortionFoodsManager.addMultiPortionFoodToPlan(food, this.schema, this.plan);
                this.foodsWithLeftPortions = multiPortionFoodsManager.getFoodsWithLeftPortions(this.schema);
            },
            action(food) {
                this.foodToShow = null;
                this.food = food;
                const ps = new PerfectScrollbar('.scrollbar');
            },
            showFoodDetails(food) {
                this.food = null;
                this.foodToShow = food;
            },
            showCreateFood() {
                this.newFood = foodFactory.create(
                    uuid(),
                    null,
                    '',
                    1,
                    null,
                    null,
                    [],
                    null,
                    ''
                );
            },
            async createOrUpdateFood(update = false) {
                this.isLoading = true;
                this.$refs.newFoodEdit.validateFood();
                if (!this.newFood.isValid()) {
                    this.isLoading = false;
                    return;
                }

                try {
                    this.newFood.regenerateHash();

                    const foodWeight = this.newFood.getTotalWeight();

                    this.newFood.portion = new Portion(this.newFood.portion.amount, foodWeight);

                    if (update) {
                      this.newFood = await FoodService.updateFood(this.newFood);
                    } else {
                      this.newFood = await FoodService.storeFood(this.newFood);
                    }

                    this.plan.addFood(this.newFood);
                    this.newFood = null;
                    this.foodsWithLeftPortions = multiPortionFoodsManager.getFoodsWithLeftPortions(this.schema);
                    this.status = true;
                } catch (error) {
                    this.status = false;
                    if (error.response && error.response.status === 409) {
                      if (error.response.data.food_uuids.length === 1) {
                        this.$dialog.confirm(trans('app.food_already_exists_in_database_update'))
                            .then(() => {
                              this.newFood.externalId = error.response.data.food_uuids[0];
                              this.createOrUpdateFood(true)
                            })
                            .catch(()=>{
                              this.status = '';
                            })
                      } else {
                        this.$toasted.global.info({message: trans('app.food_already_exists_in_database') });
                      }
                    } else {
                        this.$toasted.global.error({message: 'Danie nie zostało zapisane'});
                        this.sentryCaptureException(error);
                    }
                }
                this.isLoading = false;
            },
            hideCreateFood() {
                this.newFood = null;
            },
            hideFoodDetails() {
                this.foodToShow = null;
            },
            reload() {
                this.table.ajax.reload();
            },
            showNextPlan() {
                this.plan = this.day.getNextPlan(this.plan.id);
            },
            showPrevPlan() {
                this.plan = this.day.getPrevPlan(this.plan.id);
            },
            showNextDay() {
                this.day = this.schema.getNextNonEmptyDay(this.day.id);
                this.plan = this.day._plans[0];

            },
            showPrevDay() {
                this.day = this.schema.getPrevNonEmptyDay(this.day.id);
                this.plan = this.day._plans[0];
            },
            calculatePercentage(given, wanted) {
                if (wanted === 0)
                    return 0;

                return (given / wanted) * 100;
            },
            indicatorClass(given, wanted) {
                const percentage = this.calculatePercentage(given, wanted);

                if (percentage > 110) {
                    return 'nutrients--red';
                }

                if (percentage <= 110 && percentage >= 90) {
                    return 'nutrients--green';
                }

                return 'nutrients--primary';
            },
            setPrescribedNutrients() {
                this.prescribedNutrients[KCAL] = 0;
                this.prescribedNutrients[CARBO] = 0;
                this.prescribedNutrients[PROTEIN] = 0;
                this.prescribedNutrients[FATS] = 0;
                for(const externalId in this.MENU_PRESCRIBED_NUTRIENTS) {
                    this.prescribedNutrients[externalId] += this.MENU_PRESCRIBED_NUTRIENTS[externalId];
                }
            },

            setProductFilter(products) {
                this.filters.product = products.map(p => p.externalId);
            },
            getMultiPortionFoodColorClass(food) {
                if (food.isMultiPortionFood() === false) {
                    return '';
                }

                return multiPortionFoodsManager.getMultiPortionFoodColor(food, this.schema);
            },
            getPortionAmountOnInputListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    food.portion.amount = inputValue;
                } else if (inputValue < minValue) {
                    food.portion.amount = minValue;
                } else if (inputValue > maxValue) {
                    food.portion.amount = maxValue;
                }
            },
            getPortionAmountOnChangeListener($event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    $event.target.value = inputValue;
                } else if (inputValue < minValue) {
                    $event.target.value = $event.target.min
                } else if (inputValue > maxValue) {
                    $event.target.value = $event.target.max;
                }
            },
            getPortionAmountMax(food) {
                if (food.isMultiPortionFood()) {
                    const leftPortionsOfFood = multiPortionFoodsManager.getLeftPortionsOfFood(food, this.schema);
                    return food.portion.amount + leftPortionsOfFood;
                }
            },
            polishPlurals(singularNominativ, pluralNominativ, pluralGenitive, value) {
                return polishPlurals(singularNominativ, pluralNominativ, pluralGenitive, value);
            },
        },
        computed: {
            ...mapState({
                modalData: state => state.modal.data,
                schema: state => state.menu.schema,
            }),
            ...mapGetters([
                'getDayById',
                'configuration',
                'hasPermission',
                'configuration',
                'MENU_PRESCRIBED_NUTRIENTS',
            ]),

            databaseOptions() {
                return [
                    {value: 'all', label: 'Wszystkie'},
                    {value: 'own', label: 'Własne'},
                    {value: 'favorite', label: 'Ulubione'},
                    {value: 'shared', label: 'Udostępnione'},
                ];
            },
            nutrientsGroups() {
            if (!this.foodToShow)
              return;

            const groups = {
              'Składniki odżywcze': [],
              'Składniki mineralne': [],
              'Witaminy': [],
              'Aminokwasy': [],
              'Inne': [],
            };

            const foodNutrients = this.foodToShow.nutrients();

            for (let externalId in foodNutrients) {
              const nutrientDetails = NutrientDetailsProvider.getById(externalId);
              if (typeof nutrientDetails === 'undefined') {
                continue;
              }
              const group = nutrientDetails.groupName;
              if (!groups[group]) {
                groups[group] = [];
              }
              groups[group].push({
                name: nutrientDetails.name,
                amount: foodNutrients[externalId],
                shortName: nutrientDetails.short_name,
                position: nutrientDetails.position,
                unit: nutrientDetails.unit,
              });
            }

            groups['Inne'].push({
              amount: this.foodToShow.calculateGlicemicIndex(false),
              name: 'Indeks glikemiczny',
              shortName: 'IG'
            });

            groups['Inne'].push({
              amount: this.foodToShow.calculateGlicemicLoad(false),
              name: 'Ładunek glikemiczny',
              shortName: 'ŁG',
            });

            for (let group in groups) {
              groups[group].sort((a, b) => a.position - b.position);
            }

            return groups;
          },

            totalNutrients() {
                let total = {};
                total[KCAL] = 0;
                total[CARBO] = 0;
                total[PROTEIN] = 0;
                total[FATS] = 0;

                this.day.plans.forEach(p => {
                    total[KCAL] += p.sumNutrientById(KCAL);
                    total[CARBO] += p.sumNutrientById(CARBO);
                    total[PROTEIN] += p.sumNutrientById(PROTEIN);
                    total[FATS] += p.sumNutrientById(FATS);
                });

                return total;
            },
        },

        watch: {
            modalData: {
                immediate: true,
                handler: function (data) {
                    if (!data) return;

                    this.day = this.getDayById(data.dayId);
                    this.plan = this.day.getPlan(data.planId);

                    this.setPrescribedNutrients();
                    this.isAssignedToUser = data.isAssignedToUser;
                },
            },
            filters: {
                deep: true,
                handler: function (filters) {
                    this.debounceReload();
                },
            },
        },
    };
</script>

<style scoped>
    .add__food {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1000;
        background: #fff;
        border-width: 0 0 0 1px;
        border-style: solid;
        border-color: #d2d2d2;
        width: 50%;
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .right_box_container {
        background: #fff;
        padding: 10px;
    }

    #advanced-foods-search-table tr {
        cursor: pointer;
    }

    .day {
        max-width: 100%;
    }

    .search__container {
        display: flex;
        height: 100vh;
    }

    .search__left {
        flex: 1 1 auto;
    }

    .search__right {
        flex: 0 0 auto;
        flex-basis: 280px;
        margin: 0 15px;
    }

    .fixed {
        position: fixed;
        width: 300px;
        overflow-y: auto;
        height: 100%;
        padding: 0 0 70px;
    }

    .plan__card.selected {
        border: 2px solid #00a65a;
    }

    .flex {
        display: flex;
    }

    .flex-item {
        flex: 1;
    }

</style>
